// extracted by mini-css-extract-plugin
export default {"container":"status_container__ggSxf","icon":"status_icon__LteC+","deleted":"status_deleted__XR5LM","active":"status_active__LamgU","inactive":"status_inactive__HFtwG"};